import "jquery";
import * as ko from "knockout";
import {BaseCropComponent} from "./BaseCropComponent";
import {SamplesGroupByCropNumber } from "../Models/Crops/SamplesGroupByCropNumber";

export class Samples extends BaseCropComponent<SamplesGroupByCropNumber> {

    constructor() {
        super($('#samples-table'));
    }
    init(): void {
        this.cropsApi.getSamples().then((res) => {
            super.init(res, "cropNo", '*[data-bind="text: sampleCrop.CropNumber"]');
        });
    }
}